import Tables from 'src/class/Tables';
import i18n from 'src/i18n';


const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'file_date',
      label: i18n.t('common_words.date'),
      minWidth: 150,
    },
    {
      prop: 'hour',
      label: i18n.t('common_words.hour'),
      minWidth: 120,
    },
  ];


  return { Table };
};

export default configTable;
